// eslint-disable-next-line no-unused-vars
export default (element, data) => {
  const handleBpChange = (e) => {
    // eslint-disable-next-line no-console
    console.log('current bp: ', e.detail.bp);
  };

  const init = () => {
    window.addEventListener('bpChange', handleBpChange);
  };

  init();
};
